import './icons'

import Editor from './components/Editor'

export default {
  Sharelov: {
    Editor,
  },
}
